import {isNil} from 'ramda';
import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router';
import styled from 'styled-components';
import {BlueButton, DefaultButton, LightBlueButton, NavyButton} from '../../components/Button/ButtonMix';
import {BlueContainer} from '../../components/Container/ContainerMix';

const Logo = styled.img`
  max-width: 205px;
`;

const Heading = styled.div`
  text-align: center;
  padding: 30px 0 10px;
  & > h1 {
    color: #ffffff;
  }
  & > p {
    color: #ffffff;
  }
`;

const ScrollableBlueContainer = styled(BlueContainer)`
  overflow-y: auto !important;
`;

const Header = styled.h3`
  color: #ffffff;
  text-align: center;
  padding-bottom: 5px;
`;

const Subtext = styled.p`
  font-style: italic;
  font-size: 12px;
  padding-top: 2px;
  color: rgba(255, 255, 255, .6);
`;

const Signup = ({children, router}) => {
  const CreateOrJoin = (
    <div>
      <Header>Select your role:</Header>
      <NavyButton onClick={() => router.push('sign-up/create/schools')}>
        Coordinator
        <Subtext>Sign up a new school</Subtext>
      </NavyButton>
      <LightBlueButton onClick={() => router.push('sign-up/join/schools')}>
        Students & staff
        <Subtext>Join an existing school</Subtext>
      </LightBlueButton>
      <BlueButton onClick={() => router.push('sign-up/join/teams')}>
        Family & community
        <Subtext>Join a student or staff's team</Subtext>
      </BlueButton>
      <DefaultButton onClick={() => router.push('/')}>Cancel</DefaultButton>
    </div>
  );
  return (
    <ScrollableBlueContainer>
      <Heading>
        <Logo src="/images/logotype-white.svg" alt="Logo"/>
      </Heading>
      {isNil(children) ?
        CreateOrJoin :
        children}
    </ScrollableBlueContainer>
  );
};

Signup.propTypes = {
  children: PropTypes.element,
  router: PropTypes.object.isRequired
};

export default withRouter(Signup);



// WEBPACK FOOTER //
// ./src/pages/Login/Signup.js